import {call, put} from 'redux-saga/effects';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import {getPubPostsACS, updatePostACS} from 'store/posts/requestAC';
import {updatePostSaga} from 'store/posts/updatePost/saga';

import {addPostToFavoritesACS} from '../requestAC';

export function* addPostToFavoritesSaga(action: ReturnType<typeof addPostToFavoritesACS>) {
  const {id, favorite, getPubPostsDto} = action.payload;

  try {
    yield call(updatePostSaga, updatePostACS({id, changes: {favorite}}));
    yield put(getPubPostsACS(getPubPostsDto));
    yield put(setSuccessAC(favorite ? 'Post added to favorites' : 'Post removed from favorites'));
  } catch (error) {
    yield call(handleError, error, 'Failed to mark post as favorite');
  }
}
